<template>
  <v-avatar
    :size="avatarSize"
    :class="`user-avatar ${edit ? 'cursor-pointer' : ''}`"
    :status.attr="status"
    :edit.attr="edit"
    :large="large"
    rounded="none"
    density="compact"
    @click="handleEdit"
  >
    <v-skeleton-loader v-if="loading" type="avatar" :min-width="avatarSize" :height="avatarSize" />
    <div class="d-flex flex-column" v-else>
      <span
        v-if="large"
        class="d-flex status-icon-wrapper white--text rounded-pill px-2 py-1 body-2 medium align-center"
        :class="status ? 'secondary_text_75' : 'status_on_duty'"
      >
        <v-icon class="mr-1" size="16" color="white">{{
          status ? 'mdi-close-circle' : 'mdi-check-circle'
        }}</v-icon>
      </span>
      <v-icon
        v-else
        icon="mdi:mdi-account-circle"
        :size="iconSize ?? 48"
        :color="generateAvatarColor(initials) ?? color ?? DEFAULT_PROFILE_COLOR"
      />
    </div>
  </v-avatar>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue'
import { VAvatar } from 'vuetify/components'
import { generateAvatarColor, generateUserNameInitials } from '@/utils/helpers/generator-helpers'
import { DEFAULT_PROFILE_COLOR } from '@/utils/constants'

const SMALL_AVATAR_SIZE = 32
const DEFAULT_AVATAR_SIZE = 48
const MEDIUM_AVATAR_SIZE = 60
const LARGE_AVATAR_SIZE = 84

const props = defineProps<{
  height?: string
  width?: string
  color?: string
  status?: number
  large?: boolean
  edit?: boolean
  small?: boolean
  loading?: boolean
  textStyle?: any
  iconSize?: number
  name?: string
}>()

const initials = computed(() => (props.name ? generateUserNameInitials(props.name) : ''))

const avatarSize = computed(() => {
  if (props.large) {
    return LARGE_AVATAR_SIZE
  }
  if (props.edit) {
    return MEDIUM_AVATAR_SIZE
  }
  if (props.small) {
    return SMALL_AVATAR_SIZE
  }
  if (props.height || props.width) {
    return props.height || props.width
  }
  return DEFAULT_AVATAR_SIZE
})

const handleEdit = () => {
  if (!props.edit) return
  const file = new Window()
}
</script>

<style scoped lang="scss">
.user-avatar {
  overflow: visible;
  transition: all 0.3s;

  &::before {
    content: '';
    position: absolute;
    display: block;
    background-repeat: no-repeat;
    background-size: contain;
  }
  &[large]::before {
    display: none;
  }
  &[edit]::before {
    bottom: 2px;
    right: -2px;
    width: 20px;
    height: 20px;
  }
  &[status]::before {
    top: 2px;
    right: -2px;
    width: 14px;
    height: 14px;
    transform: scale(1.2);
  }
}
.status-icon-wrapper {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  width: max-content;
}
</style>
